// The light/dark control. Light is the default; dark only by the user's
// choice (lib/theme.ts, saved per browser).
//   ThemeSwitch  the visible row "Mode gelap" with the shared Switch, in the
//                sidebar footer above the profile or the guest prompt, the
//                admin shell, and /portal.
//   ThemeToggle  the same control as one 44px icon button (aria-pressed, the
//                moon, the sun once dark) for the collapsed rail and the
//                sign-in pages.
import { useId } from "react";
import { useTheme } from "../lib/theme";
import { Glyph } from "../ui/icons";
import { Switch } from "../ui/components";

export function ThemeSwitch() {
  const id = useId();
  const [theme, setTheme] = useTheme();
  return (
    <div className="theme-row">
      <Switch id={`${id}-theme`} label="Mode gelap" size="sm" checked={theme === "dark"} onChange={(next) => setTheme(next ? "dark" : "light")} />
    </div>
  );
}

export function ThemeToggle() {
  const [theme, setTheme] = useTheme();
  const dark = theme === "dark";
  return (
    <button type="button" className="ui-icon-btn theme-toggle" aria-label="Mode gelap" title="Mode gelap" aria-pressed={dark} onClick={() => setTheme(dark ? "light" : "dark")}>
      <Glyph name={dark ? "sun" : "moon"} />
    </button>
  );
}
